import ConnectionPointService from './service'

const useService = (overrideConfig) => {
    const connectionPointService = new ConnectionPointService(overrideConfig)
    return { connectionPointService }
}

const { connectionPointService } = useService({})

export default connectionPointService
